export const messages = {
  title: {
    id: 'admin/promotions.form.campaign.title',
  },
}
